module.exports = __webpack_public_path__ + "static/scale-model-of-public-art-\"light-gate\"-in-inglewood-california-0f226620938305f4c6b2da568628cf5d.png";